module.exports = __webpack_public_path__ + "static/media/offer-popup.2370898d.png";